import { Controller } from "@hotwired/stimulus"

const EMOJI_CATEGORIES = {
  "😊": ["😀","😃","😄","😁","😆","😅","🤣","😂","🙂","🙃","😉","😊","😇","🥰","😍","🤩","😘","😗","😚","😙","🥲","😋","😛","😜","🤪","😝","🤑","🤗","🤭","🫢","🤫","🤔","🫡","🤐","🤨","😐","😑","😶","🫥","😏","😒","🙄","😬","🤥","😌","😔","😪","🤤","😴","😷","🤒","🤕","🤢","🤮","🥵","🥶","🥴","😵","😵‍💫","🤯","🤠","🥳","🥸","😎","🤓","🧐","😕","🫤","😟","🙁","☹️","😮","😯","😲","😳","🥺","🥹","😦","😧","😨","😰","😥","😢","😭","😱","😖","😣","😞","😓","😩","😫","🥱","😤","😡","😠","🤬","😈","👿","💀","☠️","💩","🤡","👹","👺","👻","👽","👾","🤖","😺","😸","😹","😻","😼","😽","🙀","😿","😾"],
  "👋": ["👋","🤚","🖐️","✋","🖖","🫱","🫲","🫳","🫴","👌","🤌","🤏","✌️","🤞","🫰","🤟","🤘","🤙","👈","👉","👆","🖕","👇","☝️","🫵","👍","👎","✊","👊","🤛","🤜","👏","🙌","🫶","👐","🤲","🤝","🙏","✍️","💅","🤳","💪","🦾","🦿","🦵","🦶","👂","🦻","👃","🧠","🫀","🫁","🦷","🦴","👀","👁️","👅","👄","🫦","💋"],
  "👤": ["👶","👧","🧒","👦","👩","🧑","👨","👩‍🦱","🧑‍🦱","👨‍🦱","👩‍🦰","🧑‍🦰","👨‍🦰","👱‍♀️","👱","👱‍♂️","👩‍🦳","🧑‍🦳","👨‍🦳","👩‍🦲","🧑‍🦲","👨‍🦲","🧔‍♀️","🧔","🧔‍♂️","👵","🧓","👴","👲","👳‍♀️","👳","👳‍♂️","🧕","👮‍♀️","👮","👮‍♂️","👷‍♀️","👷","👷‍♂️","💂‍♀️","💂","💂‍♂️","🕵️‍♀️","🕵️","🕵️‍♂️","👩‍⚕️","🧑‍⚕️","👨‍⚕️","👩‍🌾","🧑‍🌾","👨‍🌾","👩‍🍳","🧑‍🍳","👨‍🍳","👩‍🎓","🧑‍🎓","👨‍🎓","👩‍🎤","🧑‍🎤","👨‍🎤","👩‍🏫","🧑‍🏫","👨‍🏫","👩‍🏭","🧑‍🏭","👨‍🏭","👩‍💻","🧑‍💻","👨‍💻","👩‍💼","🧑‍💼","👨‍💼","👩‍🔧","🧑‍🔧","👨‍🔧","👩‍🔬","🧑‍🔬","👨‍🔬","👩‍🎨","🧑‍🎨","👨‍🎨","👩‍🚒","🧑‍🚒","👨‍🚒","👩‍✈️","🧑‍✈️","👨‍✈️","👩‍🚀","🧑‍🚀","👨‍🚀","👩‍⚖️","🧑‍⚖️","👨‍⚖️","🤴","👸","🫅","🥷","🦸‍♀️","🦸","🦸‍♂️","🦹‍♀️","🦹","🦹‍♂️","🧙‍♀️","🧙","🧙‍♂️","🧚‍♀️","🧚","🧚‍♂️","🧛‍♀️","🧛","🧛‍♂️","🧜‍♀️","🧜","🧜‍♂️","🧝‍♀️","🧝","🧝‍♂️","🧞‍♀️","🧞","🧞‍♂️","🧟‍♀️","🧟","🧟‍♂️","🧌","💆‍♀️","💆","💆‍♂️","💇‍♀️","💇","💇‍♂️","🚶‍♀️","🚶","🚶‍♂️","🧍‍♀️","🧍","🧍‍♂️","🧎‍♀️","🧎","🧎‍♂️","🏃‍♀️","🏃","🏃‍♂️","💃","🕺","🕴️","👯‍♀️","👯","👯‍♂️"],
  "❤️": ["❤️","🧡","💛","💚","💙","💜","🖤","🤍","🤎","❤️‍🔥","❤️‍🩹","💔","❣️","💕","💞","💓","💗","💖","💘","💝","💟","♥️","💋","💯","💢","💥","💫","💦","💨","🕳️","💤","💬","👁️‍🗨️","🗨️","🗯️","💭","🫧"],
  "🐶": ["🐶","🐱","🐭","🐹","🐰","🦊","🐻","🐼","🐻‍❄️","🐨","🐯","🦁","🐮","🐷","🐽","🐸","🐵","🙈","🙉","🙊","🐒","🐔","🐧","🐦","🐤","🐣","🐥","🦆","🦅","🦉","🦇","🐺","🐗","🐴","🦄","🐝","🪱","🐛","🦋","🐌","🐞","🐜","🪲","🪳","🦟","🦗","🕷️","🕸️","🦂","🐢","🐍","🦎","🦖","🦕","🐙","🦑","🦐","🦞","🦀","🐡","🐠","🐟","🐬","🐳","🐋","🦈","🪸","🐊","🐅","🐆","🦓","🦍","🦧","🐘","🦛","🦏","🐪","🐫","🦒","🦘","🦬","🐃","🐂","🐄","🐎","🐖","🐏","🐑","🦙","🐐","🦌","🐕","🐩","🦮","🐕‍🦺","🐈","🐈‍⬛","🪶","🐓","🦃","🦤","🦚","🦜","🦢","🦩","🕊️","🐇","🦝","🦨","🦡","🦫","🦦","🦥","🐁","🐀","🐿️","🦔"],
  "🍔": ["🍇","🍈","🍉","🍊","🍋","🍋‍🟩","🍌","🍍","🥭","🍎","🍏","🍐","🍑","🍒","🍓","🫐","🥝","🍅","🫒","🥥","🥑","🍆","🥔","🥕","🌽","🌶️","🫑","🥒","🥬","🥦","🧄","🧅","🍄","🥜","🫘","🌰","🍞","🥐","🥖","🫓","🥨","🥯","🥞","🧇","🧀","🍖","🍗","🥩","🥓","🍔","🍟","🍕","🌭","🥪","🌮","🌯","🫔","🥙","🧆","🥚","🍳","🥘","🍲","🫕","🥣","🥗","🍿","🧈","🧂","🥫","🍱","🍘","🍙","🍚","🍛","🍜","🍝","🍠","🍢","🍣","🍤","🍥","🥮","🍡","🥟","🥠","🥡","🦀","🦞","🦐","🦑","🦪","🍦","🍧","🍨","🍩","🍪","🎂","🍰","🧁","🥧","🍫","🍬","🍭","🍮","🍯","🍼","🥛","☕","🫖","🍵","🍶","🍾","🍷","🍸","🍹","🍺","🍻","🥂","🥃","🫗","🥤","🧋","🧃","🧉","🧊"],
  "⚽": ["⚽","🏀","🏈","⚾","🥎","🎾","🏐","🏉","🥏","🎱","🪀","🏓","🏸","🏒","🏑","🥍","🏏","🪃","🥅","⛳","🪁","🏹","🎣","🤿","🥊","🥋","🎽","🛹","🛼","🛷","⛸️","🥌","🎿","⛷️","🏂","🪂","🏋️","🤸","🤺","⛹️","🤾","🏌️","🏇","🧘","🏄","🏊","🤽","🚣","🧗","🚵","🚴","🏆","🥇","🥈","🥉","🏅","🎖️","🏵️","🎗️","🎪","🎭","🎨","🎬","🎤","🎧","🎼","🎹","🥁","🪘","🎷","🎺","🪗","🎸","🪕","🎻","🎲","♟️","🎯","🎳","🎮","🕹️","🧩"],
  "🚗": ["🚗","🚕","🚙","🚌","🚎","🏎️","🚓","🚑","🚒","🚐","🛻","🚚","🚛","🚜","🦯","🦽","🦼","🛴","🚲","🛵","🏍️","🛺","🚍","🚘","🚖","🛞","🚡","🚠","🚟","🚃","🚋","🚞","🚝","🚄","🚅","🚈","🚂","🚆","🚇","🚊","🚉","✈️","🛫","🛬","🛩️","💺","🛰️","🚀","🛸","🚁","🛶","⛵","🚤","🛥️","🛳️","⛴️","🚢","⚓","🪝","⛽","🚧","🚦","🚥","🗺️","🗿","🗽","🗼","🏰","🏯","🏟️","🎡","🎢","🎠","⛲","⛱️","🏖️","🏝️","🏜️","🌋","⛰️","🏔️","🗻","🏕️","⛺","🛖","🏠","🏡","🏘️","🏚️","🏗️","🏭","🏢","🏬","🏣","🏤","🏥","🏦","🏨","🏪","🏫","🏩","💒","🏛️","⛪","🕌","🕍","🛕","🕋","⛩️","🛤️","🛣️","🗾","🎑","🏞️","🌅","🌄","🌠","🎇","🎆","🌇","🌆","🏙️","🌃","🌌","🌉","🌁"],
  "💡": ["⌚","📱","📲","💻","⌨️","🖥️","🖨️","🖱️","🖲️","🕹️","🗜️","💾","💿","📀","📼","📷","📸","📹","🎥","📽️","🎞️","📞","☎️","📟","📠","📺","📻","🎙️","🎚️","🎛️","🧭","⏱️","⏲️","⏰","🕰️","⌛","⏳","📡","🔋","🪫","🔌","💡","🔦","🕯️","🪔","🧯","🛢️","💸","💵","💴","💶","💷","🪙","💰","💳","💎","⚖️","🪜","🧰","🪛","🔧","🔨","⚒️","🛠️","⛏️","🪚","🔩","⚙️","🪤","🧱","⛓️","🧲","🔫","💣","🧨","🪓","🔪","🗡️","⚔️","🛡️","🚬","⚰️","🪦","⚱️","🏺","🔮","📿","🧿","🪬","💈","⚗️","🔭","🔬","🕳️","🩻","🩹","🩺","💊","💉","🩸","🧬","🦠","🧫","🧪","🌡️","🧹","🪠","🧺","🧻","🚽","🚰","🚿","🛁","🛀","🧼","🪥","🪒","🧽","🪣","🧴","🛎️","🔑","🗝️","🚪","🪑","🛋️","🛏️","🛌","🧸","🪆","🖼️","🪞","🪟","🛍️","🛒","🎁","🎈","🎏","🎀","🪄","🪅","🎊","🎉","🎎","🏮","🎐","🧧","✉️","📩","📨","📧","💌","📥","📤","📦","🏷️","🪧","📪","📫","📬","📭","📮","📯","📜","📃","📄","📑","🧾","📊","📈","📉","🗒️","🗓️","📆","📅","🗑️","📇","🗃️","🗳️","🗄️","📋","📁","📂","🗂️","🗞️","📰","📓","📔","📒","📕","📗","📘","📙","📚","📖","🔖","🧷","🔗","📎","🖇️","📐","📏","🧮","📌","📍","✂️","🖊️","🖋️","✒️","🖌️","🖍️","📝","✏️","🔍","🔎","🔏","🔐","🔒","🔓"],
  "🏁": ["🏳️","🏴","🏁","🚩","🏳️‍🌈","🏳️‍⚧️","🏴‍☠️","🇧🇷","🇺🇸","🇦🇷","🇵🇹","🇪🇸","🇫🇷","🇩🇪","🇮🇹","🇬🇧","🇯🇵","🇰🇷","🇨🇳","🇮🇳","🇲🇽","🇨🇴","🇨🇱","🇵🇪","🇺🇾","🇵🇾","🇪🇨","🇧🇴","🇻🇪","🇨🇷","🇵🇦","🇨🇺","🇩🇴","🇭🇳","🇬🇹","🇸🇻","🇳🇮","🇦🇺","🇨🇦","🇷🇺","🇹🇷","🇸🇦","🇦🇪","🇪🇬","🇳🇬","🇿🇦","🇰🇪","🇬🇭","🇲🇦","🇹🇳","🇮🇱","🇵🇰","🇧🇩","🇮🇩","🇹🇭","🇻🇳","🇵🇭","🇲🇾","🇸🇬","🇳🇿","🇸🇪","🇳🇴","🇩🇰","🇫🇮","🇮🇸","🇮🇪","🇨🇭","🇦🇹","🇧🇪","🇳🇱","🇵🇱","🇨🇿","🇷🇴","🇭🇺","🇬🇷","🇺🇦","🇭🇷"]
}

export default class extends Controller {
  static targets = ["input", "emojiBtn", "picker"]

  connect() {
    this._onSubmitEnd = () => {
      if (this.hasInputTarget) this.inputTarget.value = ""
      this.close()
    }
    this.element.addEventListener("turbo:submit-end", this._onSubmitEnd)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this._onSubmitEnd)
  }

  toggle() {
    if (this.hasPickerTarget && this.pickerTarget.classList.contains("emoji-picker--open")) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    // Close GIF picker if open
    const parent = this.element.closest("[data-controller*='gif-picker']") || this.element.parentElement
    parent?.querySelector(".gif-picker--open")?.classList.remove("gif-picker--open")
    if (!this.hasPickerTarget) this._buildPicker()
    this.pickerTarget.classList.add("emoji-picker--open")
  }

  close() {
    if (this.hasPickerTarget) {
      this.pickerTarget.classList.remove("emoji-picker--open")
    }
  }

  selectEmoji(event) {
    const emoji = event.currentTarget.dataset.emoji
    if (!emoji || !this.hasInputTarget) return
    const input = this.inputTarget
    const start = input.selectionStart
    const end = input.selectionEnd
    const value = input.value
    input.value = value.slice(0, start) + emoji + value.slice(end)
    input.selectionStart = input.selectionEnd = start + emoji.length
    input.focus()
  }

  switchTab(event) {
    const index = parseInt(event.currentTarget.dataset.tabIndex)
    const tabs = this.pickerTarget.querySelectorAll(".emoji-picker__tab")
    const grids = this.pickerTarget.querySelectorAll(".emoji-picker__grid")
    tabs.forEach((t, i) => t.classList.toggle("emoji-picker__tab--active", i === index))
    grids.forEach((g, i) => g.style.display = i === index ? "grid" : "none")
  }

  _buildPicker() {
    const picker = document.createElement("div")
    picker.className = "emoji-picker"
    picker.setAttribute("data-emoji-picker-target", "picker")

    const keys = Object.keys(EMOJI_CATEGORIES)

    // Tabs
    const tabs = document.createElement("div")
    tabs.className = "emoji-picker__tabs"
    keys.forEach((key, i) => {
      const tab = document.createElement("button")
      tab.type = "button"
      tab.className = `emoji-picker__tab${i === 0 ? " emoji-picker__tab--active" : ""}`
      tab.textContent = key
      tab.dataset.tabIndex = i
      tab.dataset.action = "click->emoji-picker#switchTab"
      tabs.appendChild(tab)
    })
    picker.appendChild(tabs)

    // Grids
    keys.forEach((key, i) => {
      const grid = document.createElement("div")
      grid.className = "emoji-picker__grid"
      grid.style.display = i === 0 ? "grid" : "none"
      for (const emoji of EMOJI_CATEGORIES[key]) {
        const btn = document.createElement("button")
        btn.type = "button"
        btn.className = "emoji-picker__item"
        btn.textContent = emoji
        btn.dataset.emoji = emoji
        btn.dataset.action = "click->emoji-picker#selectEmoji"
        grid.appendChild(btn)
      }
      picker.appendChild(grid)
    })

    // Insert before the form or at the end of the controller element
    const form = this.element.querySelector("form") || this.element.querySelector(".chat-input__form")
    if (form) {
      form.style.position = "relative"
      form.appendChild(picker)
    } else {
      this.element.style.position = "relative"
      this.element.appendChild(picker)
    }
  }
}
